export * from './addPatchMenuDTO';
export * from './addPatchPastiCollaboratoriDTO';
export * from './addPatchPastiDipendentiDTO';
export * from './addPatchPastiDocentiDTO';
export * from './addPatchPastiMenuNonOrdinarioCollaboratori';
export * from './addPatchPastiMenuNonOrdinarioDocenti';
export * from './addPatchPastiMenuNonOrdinarioPersonaleAta';
export * from './addPatchPastiMenuNonOrdinarioPersonaleTecnico';
export * from './addPatchPastiPersonaleAtaDTO';
export * from './addPatchPastiPersonaleTecnicoDTO';
export * from './addPatchRicaricaDTO';
export * from './addPatchSaldiInizialiDTO';
export * from './addPatchSaldoInizialeDTO';
export * from './aggiornamentoEventoCalendarioStudente';
export * from './aggiornamentoRicarica';
export * from './aggiornamentoStudente';
export * from './anagrafica';
export * from './anagraficaView';
export * from './anagraficaViewImpl';
export * from './annualita';
export * from './assistenzaForm';
export * from './authorityType';
export * from './authorityUser';
export * from './calendarioDTO';
export * from './calendarioScolastico';
export * from './calendarioScolasticoForm';
export * from './chiusuraDTO';
export * from './chiusuraScolastica';
export * from './chiusuraScolasticaForAllForm';
export * from './chiusuraScolasticaForm';
export * from './comune';
export * from './comuneConfigDTO';
export * from './comuneView';
export * from './comuneViewDTO';
export * from './comuneViewImpl';
export * from './comunicazionGenitoriForm';
export * from './configurazioneComuneView';
export * from './dateTimeDTO';
export * from './difformitaPastiDTO';
export * from './difformitaStudenteDTO';
export * from './esitoSincronizzazionePraticheDTO';
export * from './eventoCalendarioDTO';
export * from './eventoCalendarioDTOType';
export * from './eventoCalendarioStatus';
export * from './eventoCalendarioStudenteForm';
export * from './eventoCalendarioType';
export * from './exceptionResponseDTO';
export * from './generaDovutoDTO';
export * from './genericResponseDTO';
export * from './genitoreInfo';
export * from './genitoriSendcomunicazioneemailBody';
export * from './getDettagliScuolaDTO';
export * from './getGenitoreStudenteView';
export * from './getGenitoreStudenteViewImpl';
export * from './getMenuView';
export * from './getPastiDaPreparareDTO';
export * from './getPortafogliView';
export * from './getPortafogliViewImpl';
export * from './getRendicontazioneView';
export * from './getRicaricaNoAggiornamentiView';
export * from './getRicaricaView';
export * from './getRicaricheResponseDTO';
export * from './getScuolaDTO';
export * from './getScuolaNomePlessoIView';
export * from './getScuolaNomePlessoView';
export * from './getScuolaView';
export * from './getSezioniClassiDTO';
export * from './getStudenteDTO';
export * from './getStudenteDetailView';
export * from './getStudenteRicaricheView';
export * from './getStudenteView';
export * from './getUserProfileDTO';
export * from './giornoDellaSettimanaEnum';
export * from './identificativoMenuExtraForm';
export * from './loginResponse';
export * from './mappaPastoScuola';
export * from './menuIdMenuBody';
export * from './menuType';
export * from './multiricaricaDTO';
export * from './operatorLoginForm';
export * from './pageGetStudenteDTO';
export * from './pageGetStudenteRicaricheView';
export * from './pageRendicontazioneReportView';
export * from './pageRicaricaReportView';
export * from './pageUserViewImpl';
export * from './pageableObject';
export * from './passkeyCheckResponse';
export * from './passkeyDeviceInfo';
export * from './passkeyLoginOptionsResponse';
export * from './passkeyLoginVerifyForm';
export * from './passkeyRegistrationOptionsResponse';
export * from './passkeyRegistrationVerifyForm';
export * from './passkeyStatusResponse';
export * from './pastiCollaboratori';
export * from './pastiDipendenti';
export * from './pastiDocenti';
export * from './pastiMenuNonOrdinarioCollaboratori';
export * from './pastiMenuNonOrdinarioDocenti';
export * from './pastiMenuNonOrdinarioPersonaleAta';
export * from './pastiMenuNonOrdinarioPersonaleTecnico';
export * from './pastiNonOrdinari';
export * from './pastiNonOrdinariSpecifici';
export * from './pastiNonOrdinariStudenti';
export * from './pastiPersonaleAta';
export * from './pastiPersonaleTecnico';
export * from './patchEsenzioneDTO';
export * from './patchSospensioneStudenteDTO';
export * from './platformActionType';
export * from './portafogli';
export * from './portafogliInfo';
export * from './pushTokenDTO';
export * from './rendicontazione';
export * from './rendicontazioneReportView';
export * from './reportMensileDTO';
export * from './resendEmailRequestDTO';
export * from './resocontoCosti';
export * from './resocontoCostiScuola';
export * from './resocontoPastiClasseSezione';
export * from './resocontoPastiDipendenti';
export * from './resocontoPastiStudenti';
export * from './ricarica';
export * from './ricaricaReportView';
export * from './ricaricaStatisticheDTO';
export * from './scuola';
export * from './scuolaCreationForm';
export * from './scuolaEditForm';
export * from './scuolaGestitaDTO';
export * from './scuolaInfo';
export * from './scuolaUpdateForm';
export * from './sortObject';
export * from './statisticheMensili';
export * from './storicoCostoPasto';
export * from './storicoIsee';
export * from './storicoIseeEntry';
export * from './storicoIseeResponseDTO';
export * from './storicoIseeView';
export * from './storicoPastiUsufruiti';
export * from './studente';
export * from './studenteFilterForm';
export * from './studenteInfo';
export * from './tipologiaComune';
export * from './updateStoricoIseeForm';
export * from './updateUserPasswordForm';
export * from './user';
export * from './userEmailRequest';
export * from './userFilterForm';
export * from './userInfo';
export * from './userModificationForm';
export * from './userRegistrationForm';
export * from './userType';
export * from './userViewImpl';
export * from './v1MenuBody';
